
import { CongThucTinhDiemPage, DiemQuyDoiPage, InBangDiemPage, LoaiChungChiPage, MonHocPage, QuyChePage,
   ThanhPhanMonPage, ThanhPhanThiPage, TieuDeBaoCaoPage, XepHangTotNghiepPage, XepLoaiChungChiPage, XepLoaiHocTapPage, TongHopKyPage, 
   TongHopNamPage,
   TienDoNhapDiemLopHanhChinhPage,
   TienDoNhapDiemLopTinChiPage,
   TongHopToanKhoaPage,
   XetHocVuPage,
   XetTotNghiepPage,
   XetChungChiPage,
   XetThucTapPage,
   DiemKyHieuPage,
   ThamSoHeThongPage,
   chuongTrinhDaoTaoPage,
   BaoCaoThongKePage,
   LoaiChungChiChungNhanPage,
   LoaiBangTotNghiepPage,
   ChungChiChungNhanPage,
   QuanLyBieuMauPage,
   TraCuuDiemPage,
   NhapDiemTheoSinhVienPage,
   XetKhoaLuanPage,
   ThiLaiHocLaiPage,
   TinhTrangNoMonPage,
   HocPhanMienPage,
   TongHopToanKhoaNganh2Page,
   DanhSachNganh2Page} 
   from "../pages";

import HomePage from "../pages/home";
// import routeHoSoThau from "./routerHoSoThau";
import { IMenuViewModel } from "../model/response/auth/IMenuViewModel";

/**
 * Normalize path to ensure consistent format (always starts with /)
 */
const normalizePath = (path: string): string => {
  if (!path) return '';
  // Remove leading/trailing slashes and add one leading slash
  const cleaned = path.replace(/^\/+|\/+$/g, '');
  return cleaned ? `/${cleaned}` : '/';
};

/**
 * Flatten menu items recursively to get all paths
 */
export const flattenMenuItems = (menus: IMenuViewModel[]): string[] => {
  const paths: string[] = [];
  
  const traverse = (items: IMenuViewModel[]) => {
    items.forEach(item => {
      if (item.is_active && item.path) {
        const normalizedPath = normalizePath(item.path);
        if (normalizedPath && !paths.includes(normalizedPath)) {
          paths.push(normalizedPath);
        }
      }
      if (item.items && item.items.length > 0) {
        traverse(item.items);
      }
    });
  };
  
  traverse(menus);
  return paths;
};

/**
 * Check if user has permission to access a route
 */
export const hasRoutePermission = (routePath: string, userMenus?: IMenuViewModel[]): boolean => {
  if (!userMenus || userMenus.length === 0) {
    return false;
  }
  
  // Normalize route path
  const normalizedRoutePath = normalizePath(routePath);
  
  // Home page is always accessible
  if (normalizedRoutePath === '/home' || normalizedRoutePath === '/') {
    return true;
  }
  
  // Get all allowed paths from user menus
  const allowedPaths = flattenMenuItems(userMenus);
  
  // Check if route path matches any allowed path exactly
  // or is a sub-path of an allowed path
  return allowedPaths.some(allowedPath => {
    const normalizedAllowedPath = normalizePath(allowedPath);
    // Exact match
    if (normalizedRoutePath === normalizedAllowedPath) {
      return true;
    }
    // Sub-path match (e.g., /xet-tot-nghiep/detail matches /xet-tot-nghiep)
    if (normalizedRoutePath.startsWith(normalizedAllowedPath + '/')) {
      return true;
    }
    return false;
  });
};



const routes = [
  {
    path: "/home",
    component: HomePage,
  },
  {
    path: "/mon-hoc",
    component: MonHocPage,
  },
  {
    path: "/thanh-phan-mon",
    component: ThanhPhanMonPage,
  },
  {
    path: "/thanh-phan-thi",
    component: ThanhPhanThiPage,
  },
   {
    path: "/cong-thuc-tinh-diem",
    component: CongThucTinhDiemPage,
  },
  {
    path: "/quy-che",
    component: QuyChePage ,
  },
  {
    path: "/diem-quy-doi",
    component: DiemQuyDoiPage ,
  },
  {
    path: "/xep-loai-hoc-tap",
    component: XepLoaiHocTapPage ,
  },
   {
    path: "/xep-hang-tot-nghiep",
    component: XepHangTotNghiepPage ,
  },
   {
    path: "/xep-loai-chung-chi",
    component: XepLoaiChungChiPage ,
  },
  {
    path: "/loai-chung-chi",
    component: LoaiChungChiPage ,
  },
   {
    path: "/loai-chung-chi-chung-nhan",
    component: LoaiChungChiChungNhanPage ,
  },
   {
    path: "/loai-bang-tot-nghiep",
    component: LoaiBangTotNghiepPage ,
  },
  {
    path: "/tieu-de-bao-cao",
    component: TieuDeBaoCaoPage ,
  },
  {
    path: "/in-bang-diem",
    component: InBangDiemPage ,
  },
  {
    path: "/tong-hop-ky",
    component: TongHopKyPage ,
  },
   {
    path: "/tong-hop-nam",
    component: TongHopNamPage ,
  },
  {
    path: "/tong-hop-toan-khoa",
    component: TongHopToanKhoaPage ,
  },
  {
    path: "/tien-do-nhap-diem-lop-hanh-chinh",
    component: TienDoNhapDiemLopHanhChinhPage ,
  },
  {
    path: "/tien-do-nhap-diem-lop-tin-chi",
    component: TienDoNhapDiemLopTinChiPage ,
  },
  {
    path: "/xet-hoc-vu",
    component: XetHocVuPage ,
  },
  {
    path: "/xet-khoa-luan",
    component: XetKhoaLuanPage,
  },
  {
    path: "/xet-tot-nghiep",
    component: XetTotNghiepPage ,
  },
   {
    path: "/xet-chung-chi",
    component: XetChungChiPage ,
  },
   {
    path: "/xet-thuc-tap",
    component: XetThucTapPage ,
  },
    {
    path: "/tham-so-he-thong",
    component: ThamSoHeThongPage,
  },
  {
    path: "/quan-ly-bieu-mau",
    component: QuanLyBieuMauPage,
  },
  {
    path: "/chuong-trinh-dao-tao",
    component: chuongTrinhDaoTaoPage,
  },
   {
    path: "/diem-ky-hieu",
    component: DiemKyHieuPage,
  },
  {
    path: "/bao-cao-thong-ke",
    component: BaoCaoThongKePage,
  },
   {
    path: "/chung-chi-chung-nhan",
    component: ChungChiChungNhanPage,
  },
  {
    path: "/tra-cuu-diem",
    component: TraCuuDiemPage,
  },
  {
    path: "/nhap-diem-theo-sinh-vien",
    component: NhapDiemTheoSinhVienPage,
  },
  {
    path: "/thi-lai-hoc-lai",
    component: ThiLaiHocLaiPage,
  },
  {
    path: "/tinh-trang-no-mon",
    component: TinhTrangNoMonPage,
  },
  {
    path: "/hoc-phan-mien",
    component: HocPhanMienPage,
  },
  {
    path: "/danh-sach-nganh-2",
    component: DanhSachNganh2Page,
  },
  {
    path: "/tong-hop-toan-khoa-nganh-2",
    component: TongHopToanKhoaNganh2Page,
  },
  // ...routeHoSoThau,
];
export default routes.map((route) => {
  return {
    ...route,
  };
});





